/**
 * köbi Produktgalerie — Helligkeit-Erkennung
 * Liest die Bildhelligkeit des aktuellen Slides und schaltet die
 * Dots-Bar zwischen dark/light um, damit die Indikatoren immer sichtbar sind.
 */
(function () {
  'use strict';

  /**
   * Analysiert die wahrgenommene Helligkeit (0–255) eines Bildes via Canvas.
   * Wir samplen die gesamte Fläche auf 16×16 px herunter.
   */
  function getImageBrightness(src) {
    return new Promise(function (resolve) {
      var img = new Image();
      img.crossOrigin = 'anonymous';
      img.onload = function () {
        try {
          var canvas = document.createElement('canvas');
          canvas.width = 16;
          canvas.height = 16;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, 16, 16);
          var data = ctx.getImageData(0, 0, 16, 16).data;
          var total = 0;
          var count = data.length / 4;
          for (var i = 0; i < data.length; i += 4) {
            // Wahrgenommene Helligkeit (Luma)
            total += data[i] * 0.299 + data[i + 1] * 0.587 + data[i + 2] * 0.114;
          }
          resolve(total / count);
        } catch (e) {
          resolve(200); // Fallback: hell → dunkle Dots
        }
      };
      img.onerror = function () {
        resolve(200);
      };
      img.src = src;
    });
  }

  function updateGallery(gallery, slide) {
    var img = slide.querySelector('img');
    if (!img) return;

    // currentSrc bevorzugen (responsives Bild), sonst src
    var src = img.currentSrc || img.src;
    if (!src) return;

    getImageBrightness(src).then(function (brightness) {
      // Threshold 140: darunter gilt das Bild als dunkel → helle Pfeile.
      // Klasse sitzt auf der Galerie selbst → nur die Pfeile (auf dem Bild)
      // reagieren darauf, die Dots-Bar (unter dem Bild) nicht.
      gallery.classList.toggle('koebi-gallery--dark-img', brightness < 140);
    });
  }

  function initGallery(gallery) {
    // Erstes Slide analysieren
    var firstSlide = gallery.querySelector('.slideshow__slide.is-active, .slideshow__slide:first-child');
    if (firstSlide) updateGallery(gallery, firstSlide);

    // Bei Slide-Wechsel
    gallery.addEventListener('slideChanged', function (event) {
      var slide = event.detail && event.detail.currentElement;
      if (slide) updateGallery(gallery, slide);
    });
  }

  function init() {
    document.querySelectorAll('.koebi-product-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
